import { TemplateConfig } from '../types';

export const thoughtsDevelopmentConfig: TemplateConfig = {
  id: 'thoughts-development',
  name: '想法和发展牌阵',
  description: '分析对方对自己的想法以及事件的未来发展趋势',
  cardCount: 6,
  
  fieldDefaults: {
    title: '想法和发展牌阵',
    customerQuestion: '想看到对方对自己的想法、以及后续未来的发展趋势如何；并且可以占ト一个事件中对方的想法以及事件的未来发展。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 1 行第 3 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌'
    ],
    cardInfos: [
      '对方的想法',
      '对方的想法',
      '对方的想法',
      '未来的发展',
      '未来的发展',
      '未来的发展'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '🔮'
  }
};